export const formatNumber = (
  number: number,
  thousandsSeparator: string = " ",
  decimalSeparator: string = ",",
) => {
  return number
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
    .replace(".", decimalSeparator);
};
